export const DOMAIN_DKIM_STATUS = {
  CONNECTED: 'Active',
  NOT_CONNECTED: 'Not connected',
};
